import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FastQuoteBids } from '@app-model/evaluation';
import { ProposalMarginLimitHelper } from '@app-model/proposal-margin.model';
import {
  belowMinimumMarginMessage,
  formatMarginPercent,
  getProposalMargin,
  isBelowUserMarginLimit,
} from '@app-utils/proposal-margin.utils';
import { SessionService } from 'src/app/store/session/session.service';
import { UserInfo } from '@app/store/session/session.store';

export interface DialogAcceptFastQuoteBidData {
  vehicle: FastQuoteBids;
  value: number;
  costPrice?: number | null;
  marginLimit?: ProposalMarginLimitHelper | null;
}

@Component({
  selector: 'app-dialog-accept-fast-quote-bid',
  templateUrl: './dialog-accept-fast-quote-bid.html',
  styleUrls: ['./dialog-accept-fast-quote-bid.component.scss']
})
export class DialogAcceptFastQuoteBidComponent implements OnInit {
  vehicle: FastQuoteBids;
  value: number;
  costPrice: number | null = null;
  marginLimit: ProposalMarginLimitHelper | null = null;
  private userInfo: UserInfo;

  constructor(
    private dialogRef: MatDialogRef<DialogAcceptFastQuoteBidComponent>,
    private sessionService: SessionService,
    @Inject(MAT_DIALOG_DATA) public data: DialogAcceptFastQuoteBidData,
  ) {
    this.vehicle = data?.vehicle;
    this.value = data?.value;
    this.costPrice = data?.costPrice ?? null;
    this.marginLimit = data?.marginLimit ?? null;
  }

  ngOnInit(): void {
    this.sessionService.getUser().subscribe((user) => {
      this.userInfo = user;
    });
  }

  get proposalMargin(): number | undefined {
    return getProposalMargin(this.value, this.costPrice);
  }

  get userLimitLabel(): string | null {
    const limit = this.marginLimit?.effectiveLimit;
    if (limit == null) {
      return null;
    }
    return formatMarginPercent(limit);
  }

  get isMarginBlocked(): boolean {
    const min = this.marginLimit?.minimumProposalAcceptanceMargin ?? null;
    const limit = this.marginLimit?.effectiveLimit ?? null;
    const canAcceptBelow = this.userInfo?.canAcceptProposalBelowMargin() ?? false;
    return isBelowUserMarginLimit(this.value, this.costPrice, min, limit, canAcceptBelow);
  }

  get marginBlockMessage(): string {
    return belowMinimumMarginMessage(this.marginLimit?.effectiveLimit);
  }

  @HostListener('window:keyup.esc')
  onNoClick(): void {
    this.dialogRef.close();
  }

  onClickConfirm(): void {
    if (this.isMarginBlocked) {
      return;
    }
    this.dialogRef.close(true);
  }
}
